/**
 * Application Constants
 * All magic numbers and configuration values in one place
 */

// ============================================
// PDF Template Constants
// ============================================
export const PDF_TEMPLATE = {
  // Base dimensions (A4 in points)
  BASE_WIDTH: 595,
  BASE_HEIGHT: 842,
  
  // Page to place signature
  PAGE_INDEX: 0,
  
  // Signature rectangle position and size (recuadro "Firmado" del centro)
  SIGNATURE_RECT: {
    X: 280,        // Posición horizontal del recuadro "Firmado" (centrado)
    Y_TOP: 720,    // Posición Y desde arriba
    WIDTH: 175,    // Ancho del recuadro "Firmado"
    HEIGHT: 120,   // Alto del recuadro "Firmado"
    // These shifts are NOT scaled with page dimensions
    SHIFT_X: 0,    // Sin desplazamiento horizontal adicional
    SHIFT_Y: 0,    // Sin desplazamiento vertical adicional
  },
  
  // Signature layout constants
  LAYOUT: {
    PADDING: 6,
    FONT_SIZE: 10,
    LINE_HEIGHT: 12,
    GAP: 4,
    TEXT_RIGHT_PAD: -4,
  },
};

// ============================================
// File Constraints
// ============================================
export const FILE_CONSTRAINTS = {
  MAX_SIZE_MB: 10,
  MAX_SIZE_BYTES: 10 * 1024 * 1024,
  ALLOWED_TYPE: "application/pdf",
  ALLOWED_MIME_TYPES: ["application/pdf"],
};

// ============================================
// Phone Number Defaults
// ============================================
export const PHONE_DEFAULTS = {
  COUNTRY_CODE: "+34",
  MIN_LENGTH: 6,
  MAX_LENGTH: 20,
};

// ============================================
// Email Configuration
// ============================================
export const EMAIL_CONFIG = {
  MAX_ATTACHMENT_SIZE_MB: 10,
  MAX_ATTACHMENT_SIZE_BYTES: 10 * 1024 * 1024,
};

// ============================================
// Toast Durations
// ============================================
export const TOAST_DURATION = {
  SHORT: 2000,
  NORMAL: 3000,
  LONG: 5000,
  PERSISTENT: 0, // Won't auto-dismiss
};

// ============================================
// Expiration Defaults
// ============================================
export const EXPIRATION = {
  DEFAULT_DAY_OF_MONTH: 6,
  DEFAULT_DAYS_FROM_CREATION: 7,
};

// ============================================
// UI Breakpoints
// ============================================
export const BREAKPOINTS = {
  MOBILE: 560,
  TABLET: 768,
  DESKTOP: 1024,
};

// ============================================
// Storage Paths
// ============================================
export const STORAGE_PATHS = {
  UPLOADS: "uploads",
  SIGNED: "signed",
  TEMP: "temp",
};

// ============================================
// Collection Names
// ============================================
export const COLLECTIONS = {
  REQUESTS: "requests",
  PRL_REQUESTS: "prl_requests",
  CONTACTS: "contacts",
  CONFIG: "config",
  // Permission system collections
  PERMISSION_PROFILES: "permission_profiles",
  USER_PERMISSIONS: "user_permissions",
  COMPANY_PERMISSIONS: "company_permissions",
};

// ============================================
// Request Status
// ============================================
export const REQUEST_STATUS = {
  PENDING: "pending",
  SIGNED: "signed",
  EXPIRED: "expired",
};

// ============================================
// Contact Types
// ============================================
export const CONTACT_TYPE = {
  EMAIL: "email",
  PHONE: "phone",
};

// ============================================
// QR Code Configuration
// ============================================
export const QR_CONFIG = {
  WIDTH: 512,
  MARGIN: 1,
  DISPLAY_SIZE: 260,
};
